import type { Lang } from "./ajuda";

export const traducoesSuporte: Record<Lang, {
  headerSubtitle: string;
  heroTitle: string;
  searchPlaceholder: string;
  searchButton: string;
  heroHint: string;
  faqTitle: string;
  faqItems: { pergunta: string; descricao: string }[];
  needAnotherHelp: string;
  bannerTitle: string;
  bannerDescription: string;
  bannerCta: string;
  trustTitle: string;
  trustSupport: string;
  trustDescription: string;
  trustGreat: string;
  verificarTitle: string;
  verificarDescription: string;
  verificarPlaceholder: string;
  verificarButton: string;
  footerBrand: string;
  footerTagline: string;
  footerProducts: string;
  footerFaq: string;
  footerSecure: string;
  footerChannels: string;
  footerEmail: string;
  footerHours: string;
  footerTerms: string;
  footerPrivacy: string;
  footerTermsUse: string;
  footerCopyright: string;
  footerAttendance: string;
}> = {
  pt: {
    headerSubtitle: "Central de Suporte",
    heroTitle: "Como podemos ajudar?",
    searchPlaceholder: "Descobrir o problema",
    searchButton: "Buscar",
    heroHint: "Ou abra o chat no canto inferior direito para falar com nosso assistente.",
    faqTitle: "Dúvidas frequentes",
    faqItems: [
      { pergunta: "Como emitir meu certificado?", descricao: "Acesse sua área do aluno e solicite na seção de certificados." },
      { pergunta: "Esqueci minha senha, e agora?", descricao: 'Use "Esqueci minha senha" na tela de login para redefinir.' },
      { pergunta: "Acessar manuais complementares", descricao: "Disponíveis na Central de Ajuda e no seu painel." },
      { pergunta: "Como cancelar minha assinatura?", descricao: "Configurações da conta ou entre em contato com o suporte." },
      { pergunta: "Problemas de acesso à plataforma", descricao: "Verifique sua conexão ou limpe o cache do navegador." },
      { pergunta: "Alterar data ou forma de pagamento", descricao: "Em configurações > assinatura você pode atualizar." },
    ],
    needAnotherHelp: "Precisa de ajuda com outra dúvida?",
    bannerTitle: "FAQ — Conheça nossa Central de Ajuda",
    bannerDescription: "Por lá, você encontra as perguntas mais frequentes, tutoriais e artigos para tirar dúvidas.",
    bannerCta: "Acessar a Central de Ajuda",
    trustTitle: "Por que nos escolher?",
    trustSupport: "Suporte confiável",
    trustDescription: "Respostas rápidas e precisas com nossa equipe e assistente com IA.",
    trustGreat: "Ótimo",
    verificarTitle: "Verifique o número do nosso time",
    verificarDescription: "Preencha o campo abaixo com o número de celular ou e-mail para verificar se é nosso canal oficial.",
    verificarPlaceholder: "Digite o CPF/CNPJ ou e-mail",
    verificarButton: "Verificar Número",
    footerBrand: "Venda Todo Santo Dia",
    footerTagline: "Suporte inteligente com IA",
    footerProducts: "Produtos e serviços",
    footerFaq: "FAQ",
    footerSecure: "Site Seguro",
    footerChannels: "Canais de atendimento",
    footerEmail: "E-mail",
    footerHours: "Seg–sex, 9h–18h",
    footerTerms: "Termos e políticas",
    footerPrivacy: "Política de privacidade",
    footerTermsUse: "Termos de uso",
    footerCopyright: "Todos os direitos reservados.",
    footerAttendance: "Atendimento humano seg–sex, 9h–18h (horário de Brasília)",
  },
  en: {
    headerSubtitle: "Support Center",
    heroTitle: "How can we help?",
    searchPlaceholder: "Find the issue",
    searchButton: "Search",
    heroHint: "Or open the chat in the bottom right corner to talk to our assistant.",
    faqTitle: "Frequently asked questions",
    faqItems: [
      { pergunta: "How do I issue my certificate?", descricao: "Access your student area and request it in the certificates section." },
      { pergunta: "I forgot my password, what now?", descricao: 'Use "Forgot password" on the login screen to reset.' },
      { pergunta: "Access supplementary manuals", descricao: "Available in the Help Center and your dashboard." },
      { pergunta: "How do I cancel my subscription?", descricao: "Account settings or contact support." },
      { pergunta: "Platform access issues", descricao: "Check your connection or clear your browser cache." },
      { pergunta: "Change payment date or method", descricao: "In settings > subscription you can update." },
    ],
    needAnotherHelp: "Need help with something else?",
    bannerTitle: "FAQ — Get to know our Help Center",
    bannerDescription: "There you'll find the most frequently asked questions, tutorials and articles.",
    bannerCta: "Access the Help Center",
    trustTitle: "Why choose us?",
    trustSupport: "Reliable support",
    trustDescription: "Fast and accurate answers with our team and AI assistant.",
    trustGreat: "Great",
    verificarTitle: "Verify our team number",
    verificarDescription: "Fill in the field below with your phone or email to verify it's our official channel.",
    verificarPlaceholder: "Enter CPF/CNPJ or email",
    verificarButton: "Verify Number",
    footerBrand: "Venda Todo Santo Dia",
    footerTagline: "Smart support with AI",
    footerProducts: "Products and services",
    footerFaq: "FAQ",
    footerSecure: "Secure Site",
    footerChannels: "Support channels",
    footerEmail: "Email",
    footerHours: "Mon–Fri, 9am–6pm",
    footerTerms: "Terms and policies",
    footerPrivacy: "Privacy policy",
    footerTermsUse: "Terms of use",
    footerCopyright: "All rights reserved.",
    footerAttendance: "Human support Mon–Fri, 9am–6pm (Brasília time)",
  },
  es: {
    headerSubtitle: "Centro de Soporte",
    heroTitle: "¿Cómo podemos ayudarte?",
    searchPlaceholder: "Descubrir el problema",
    searchButton: "Buscar",
    heroHint: "O abre el chat en la esquina inferior derecha para hablar con nuestro asistente.",
    faqTitle: "Preguntas frecuentes",
    faqItems: [
      { pergunta: "¿Cómo emito mi certificado?", descricao: "Accede a tu área del alumno y solicítalo en la sección de certificados." },
      { pergunta: "Olvidé mi contraseña, ¿y ahora?", descricao: 'Usa "Olvidé mi contraseña" en la pantalla de inicio de sesión.' },
      { pergunta: "Acceder a manuales complementarios", descricao: "Disponibles en el Centro de Ayuda y en tu panel." },
      { pergunta: "¿Cómo cancelo mi suscripción?", descricao: "Configuración de la cuenta o contacta a soporte." },
      { pergunta: "Problemas de acceso a la plataforma", descricao: "Verifica tu conexión o limpia la caché del navegador." },
      { pergunta: "Cambiar fecha o forma de pago", descricao: "En configuración > suscripción puedes actualizar." },
    ],
    needAnotherHelp: "¿Necesitas ayuda con otra duda?",
    bannerTitle: "FAQ — Conoce nuestro Centro de Ayuda",
    bannerDescription: "Ahí encontrarás las preguntas más frecuentes, tutoriales y artículos.",
    bannerCta: "Acceder al Centro de Ayuda",
    trustTitle: "¿Por qué elegirnos?",
    trustSupport: "Soporte confiable",
    trustDescription: "Respuestas rápidas y precisas con nuestro equipo y asistente con IA.",
    trustGreat: "Genial",
    verificarTitle: "Verifica el número de nuestro equipo",
    verificarDescription: "Completa el campo con tu teléfono o correo para verificar si es nuestro canal oficial.",
    verificarPlaceholder: "Ingresa CPF/CNPJ o correo",
    verificarButton: "Verificar Número",
    footerBrand: "Venda Todo Santo Dia",
    footerTagline: "Soporte inteligente con IA",
    footerProducts: "Productos y servicios",
    footerFaq: "FAQ",
    footerSecure: "Sitio seguro",
    footerChannels: "Canales de atención",
    footerEmail: "Correo",
    footerHours: "Lun–vie, 9h–18h",
    footerTerms: "Términos y políticas",
    footerPrivacy: "Política de privacidad",
    footerTermsUse: "Términos de uso",
    footerCopyright: "Todos los derechos reservados.",
    footerAttendance: "Atención humana lun–vie, 9h–18h (horario de Brasília)",
  },
};
